import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import './TypeContract.css';

const TypeContract = ({ enca, isVisible, onClose }) => {

    const [isSaas, setIsSaas] = useState(null);
    const [applyAll, setApplyAll] = useState(null);

    const handleConfirm = () => {
        onClose({
            isSaas: isSaas === true,
            applyAll: applyAll === true,
        });
        // reset interno para la próxima vez que se abra
        setIsSaas(null);
        setApplyAll(null);
    };

    const canConfirm = isSaas !== null && (isSaas === false || applyAll !== null);

    return (
        isVisible && (
            <div className="info-notification-info-overlay">
                <div className="info-notification-info">
                    <div className="icon-container-noti-info">
                        <FontAwesomeIcon icon={faCircleQuestion} className="icon-noti4" />
                    </div>
                    <div className="message-container-info">
                        <h4>{enca || 'Información'}</h4>

                        <div className="module-type-question">
                            <p>¿Este contrato es SaaS (Software como servicio)?</p>
                            <div className="button-container-info">
                                <button
                                    className={`ok-btn-info2 ${isSaas === true ? 'selected' : ''}`}
                                    onClick={() => setIsSaas(true)}
                                >
                                    Sí
                                </button>
                                <button
                                    className={`ok-btn-info2 ${isSaas === false ? 'selected' : ''}`}
                                    onClick={() => { setIsSaas(false); setApplyAll(null); }}
                                >
                                    No
                                </button>
                            </div>
                        </div>

                        {isSaas === true && (
                            <div className="module-type-question">
                                <p>¿Desea aplicar SaaS (Software como servicio) a todos los módulos?</p>
                                <div className="button-container-info">
                                    <button
                                        className={`ok-btn-info2 ${applyAll === true ? 'selected' : ''}`}
                                        onClick={() => setApplyAll(true)}
                                    >
                                        Sí
                                    </button>
                                    <button
                                        className={`ok-btn-info2 ${applyAll === false ? 'selected' : ''}`}
                                        onClick={() => setApplyAll(false)}
                                    >
                                        No
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="button-container-info">
                        <button
                            className="ok-btn-info"
                            disabled={!canConfirm}
                            onClick={handleConfirm}
                        >
                            Confirmar
                        </button>
                    </div>
                </div>
            </div>
        )
    );
};

export default TypeContract;